<div class="content-wrp mt-3">
  <div class="tab-content" id="lab-environment-tab">
    <!-- Azure Tab -->
    <div class="guide-tabs mb-2" [class.showtab]="selectedTab === 'Azure'">

      <div *ngIf="labDetail.AllowExistingAD" class="d-flex align-items-start p-3 mb-3 border rounded alert-bg"
        style="background-color: #f0f6ff; border-color: #b6d4fe;">
        <!-- Icon -->
        <div class="mr-3">
          <i class="fa-solid fa-info-circle text-primary" style="font-size: 22px;"></i>
        </div>

        <!-- Text -->
        <div class="flex-fill" [innerHTML]="'AZURE_LOGIN' | translate: {AADEmail: cloudprovider.AADEmail}">
        </div>

      </div>
      <div class="row" *ngIf="labDetail.DoNotSendCloudCredentials !== true && labDetail.AllowExistingAD !== true">
        <!-- <div class="col-md-12 pt-2 pb-4" *ngIf="!cloudprovider?.CustomInstruction">

          <div class="alert d-flex align-items-center info-box alert-bg" role="alert">
            <i class="fa-solid fa-info-circle mr-3 info-icon"></i>
            <div id="instructions-azure-login" [innerHTML]="'INSTRUCTION_AZURE_LOGIN_RDP' | translate">
            </div>

          </div>

        </div> -->
        <div class="col-md-12">
          <!--Auth Section -->
          <div class="card border rounded-lg mb-4">

            <!-- Header -->
            <div class="bg-light-primary card-header d-flex justify-content-between align-items-center py-2 px-3">

              <div class="font-weight-bold font-14 mb-0" *ngIf="cloudprovider.CloudPlatformId === 1">
                <img src="../../../../assets/images/azure.png" alt="Azure logo" width="26" class="icon-size mr-2">
                {{ 'AZURE_CREDENTIAL' | translate }}
              </div>

              <a href="https://portal.azure.com" target="_blank" [attr.aria-label]="'CLICK_HERE_TO_LOGIN' | translate"
                class="text-primary font-weight-bold text-decoration-none font-12">
                {{ 'CLICK_HERE_TO_LOGIN' | translate }}
              </a>

            </div>

            <!-- Username -->
            <div class="d-flex justify-content-between align-items-center px-3 py-2 border-top">

              <div class="pr-3 flex-grow-1 overflow-hidden">
                <div class="text-muted font-12 mb-1">
                  {{ 'USERNAME' | translate }}
                </div>

                <div class="mb-0 font-14 text-truncate w-100">
                  {{ cloudprovider.AADEmail }}
                </div>
              </div>

              <a role="button" ngxClipboard class="ml-2"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('USERNAME' | translate) + ' : ' + cloudprovider.AADEmail"
                [cbContent]="cloudprovider.AADEmail" href="javascript:void(0)" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                [attr.aria-label]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' username'">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

            <!-- Password -->
            <div class="d-flex justify-content-between align-items-center px-3 py-2 border-top">

              <div class="pr-3 flex-grow-1 overflow-hidden">
                <!-- TEMP ACCESS PASS -->
                <span class="text-muted font-12 d-flex align-items-center mb-1"
                  *ngIf="cloudprovider.EnableTemporaryAccessPass">
                  {{ 'TEMP_ACCESS_PASS' | translate }}
                  <i class="pi pi-info-circle ml-1" tabindex="0" style="cursor: pointer" (click)="op.toggle($event)" (keydown.enter)="op.toggle($event)">
                  </i>

                  <p-overlayPanel #op [dismissable]="true" [showCloseIcon]="false">
                    <div style="max-width: 300px;" [innerHTML]="'TEMP_ACCESS_PASS_INFO_MSG' | translate">
                    </div>
                  </p-overlayPanel>
                </span>

                <span class="text-muted font-12 mb-1" *ngIf="!cloudprovider.EnableTemporaryAccessPass">
                  {{ 'PASSWORD' | translate }}
                </span>

                <div class="font-14 mb-0 text-truncate w-100">
                  {{ cloudprovider.TempPassword }}
                </div>

              </div>
              <a role="button" ngxClipboard class="ml-2"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ((cloudprovider?.EnableTemporaryAccessPass ? 'TEMP_ACCESS_PASS' : 'PASSWORD_LABEL') | translate) + ' : ' + cloudprovider.TempPassword"
                [cbContent]="cloudprovider.TempPassword" href="javascript:void(0)"
                [id]="pasteInVM ? 'pasteInsideVM' : ''"
                [attr.aria-label]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' password'">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

          </div>
        </div>
      </div>
      <!--New Multiple RG Groups -->
      <div class="accroding-sec-2" *ngIf="cloudprovider.DeploymentOutputValues?.length > 1 && outputParameter">

        <div *ngFor="let rg of cloudprovider.DeploymentOutputValues; let indexOfElement = index; trackBy: trackByFn"
          class="mb-4">

          <!-- Header -->
          <div class="card border rounded-lg shadow-sm overflow-hidden">

            <!-- Clickable Header -->
            <div class="card-header bg-light-primary px-4 py-3 d-flex justify-content-between align-items-center"
              style="cursor:pointer;" tabindex="0" (click)="onToggle(indexOfElement)"
              (keyup.enter)="onToggle(indexOfElement)">

              <div class="d-flex align-items-center">

                <i class="fa-solid fa-flask text-primary mr-3"></i>

                <strong class="font-14 mb-0">
                  {{ 'ENVIRONMENT_INFORMATION' | translate }}: {{ rg.ResourceGroupName }}
                </strong>

              </div>

              <!-- Expand Collapse -->
              <i class="fa-solid text-secondary"
                [ngClass]="accordionToggleInfo[indexOfElement] ? 'fa-chevron-up' : 'fa-chevron-down'">
              </i>

            </div>

            <!-- Body -->
            <div *ngIf="accordionToggleInfo[indexOfElement]">

              <div class="card-body p-0">

                <ng-container *ngFor="let row of rg.OutputValues">

                  <div *ngIf="!row.ExcludeOutputParameter"
                    class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                    <!-- Left -->
                    <div class="pr-3 flex-grow-1 overflow-hidden">

                      <div class="text-muted mb-1 font-12">
                        {{ row.Name | pascalCase }}
                      </div>

                      <div class="font-14 mb-0 text-truncate w-100">
                        {{ row.Value }}
                      </div>

                    </div>

                    <!-- Copy -->
                    <a role="button" ngxClipboard [id]="pasteInVM ? 'pasteInsideVM' : ''"
                      [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + row.Name + ' : ' + row.Value"
                      [attr.aria-label]="'CLICK_TO_COPY_FIELD' | translate:{ field: row.Name}" [cbContent]="row.Value"
                      href="javascript:void(0)">
                      <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                        [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                        [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                    </a>

                  </div>

                </ng-container>

              </div>

            </div>

          </div>

        </div>

      </div>
      <!-- New Single RG Group -->
      <div *ngIf="cloudprovider.DeploymentOutputValues?.length === 1 && outputParameter">

        <div class="row" *ngFor="let rg of cloudprovider.DeploymentOutputValues">

          <ng-container *ngIf="rg?.OutputValues?.length > 0">

            <div class="col-md-12">

              <!-- Modern Card -->
              <div class="card border rounded-lg shadow-sm mb-4 overflow-hidden">

                <!-- Header -->
                <div class="card-header bg-light-primary px-4 py-3 d-flex align-items-center">

                  <i class="fa-solid fa-flask text-primary mr-3"></i>

                  <strong class="font-14 mb-0">
                    {{ 'ENVIRONMENT_INFORMATION' | translate }}: {{ rg.ResourceGroupName }}
                  </strong>

                </div>

                <!-- Rows -->
                <div class="card-body p-0">

                  <ng-container *ngFor="let row of rg.OutputValues">

                    <div *ngIf="row.ExcludeOutputParameter === false"
                      class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                      <!-- Left -->
                      <div class="pr-3 flex-grow-1 overflow-hidden">

                        <div class="text-muted font-12 mb-1 font-weight-normal">
                          {{ row.Name | pascalCase }}
                        </div>

                        <div class="font-14 mb-0 text-truncate w-100">
                          {{ row.Value }}
                        </div>

                      </div>

                      <!-- Copy -->
                      <a role="button" ngxClipboard class="ml-2" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                        [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' +  (row.Name | pascalCase) + ' : ' + row.Value"
                        [attr.aria-label]="'CLICK_TO_COPY_FIELD' | translate:{ field: row.Name}" [cbContent]="row.Value"
                        href="javascript:void(0)">
                        <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                          [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                          [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                      </a>

                    </div>

                  </ng-container>

                </div>

              </div>

            </div>

          </ng-container>

        </div>

      </div>
      <div class="row pb-4 lab_Urls font-14">
        <div class="col-md-12">
          <div *ngIf="attendeLabDetails.LabGuideUrl && attendeLabDetails.LabGuideUrl !== null && attendeLabDetails.LabGuideUrl !== '' && type === null"
            style="padding: 5px 0">
            <span><strong>{{ 'LAB_GUIDE' | translate }} </strong><a role="link" aria-label="Labguide url"
                [href]="attendeLabDetails.LabGuideUrl" target="_blank">{{"CLICK_HERE" | translate}}</a></span>
          </div>
          <div *ngIf="attendeLabDetails.LabInformationURL && attendeLabDetails.LabInformationURL !=='' && attendeLabDetails.LabInformationURL !== null"
            class="" style="padding: 5px 0">
            <span><strong>{{ 'HELP_DOCUMEN_URL' | translate}} </strong><a role="link" aria-label="button"
                href="{{attendeLabDetails.LabInformationURL}}" target="_blank">{{"CLICK_HERE" |
                translate}}</a></span>
          </div>
          <div *ngIf="attendeLabDetails.PreGuideUrl && attendeLabDetails.PreGuideUrl !=='' && attendeLabDetails.PreGuideUrl !== null"
            style="padding: 5px 0;">
            <span>{{ 'INSTRUCTION_PREREQUISITES_FOR_LAB' | translate}} <a role="link" aria-label="button"
                href="{{attendeLabDetails.PreGuideUrl}}" target="_blank">{{"CLICK_HERE" | translate}}</a></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Microsoft Account Credentials -->
    <div class="guide-tabs mb-2" [class.showtab]="selectedTab === 'Ms'"
      *ngIf="mode===operationModes.AZUREPASSUSERDETAILS">

      <!-- SYSTEM GENERATED -->
      <div class="row" *ngIf="attendeLabDetails.AADEmail !== null">

        <div class="col-md-12">

          <!-- Info -->
          <div class="alert alert-primary border mb-4">
            <i class="fa-solid fa-info-circle mr-2"></i>
            <span [innerHTML]="'AZURE_PASS_SYS_DIRECTORY' | translate : {TabName: labDetail.LicenseLabel}">
            </span>
          </div>

          <!-- Modern Card -->
          <div class="card border rounded-lg shadow-sm overflow-hidden">

            <!-- Header -->
            <div class="card-header bg-light-primary py-2 px-3 d-flex align-items-center">

              <i class="fa-solid fa-windows text-primary mr-3"></i>

              <strong class="font-14 mb-0">
                {{ 'HEADING_MICROSOFT_ACCOUNT_CREDENTIALS' | translate }}
              </strong>

            </div>

            <!-- Username -->
            <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

              <div class="pr-3 flex-grow-1 overflow-hidden">

                <div class="text-muted mb-1 font-12">
                  {{ 'USERNAME' | translate }}
                </div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="attendeLabDetails.AADEmail">
                  {{ attendeLabDetails.AADEmail }}
                </div>

              </div>
              <a role="button" ngxClipboard class="ml-2"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('USERNAME' | translate) + ' : ' + attendeLabDetails.AADEmail"
                [cbContent]="attendeLabDetails.AADEmail" href="javascript:void(0)"
                [id]="pasteInVM ? 'pasteInsideVM' : ''" attr.aria-label="{{'COPY' | translate}} Username">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

            <!-- Password -->
            <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

              <div class="pr-3 flex-grow-1 overflow-hidden">

                <div class="text-muted mb-1 font-12">
                  {{ 'PASSWORD' | translate }}
                </div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="attendeLabDetails.TempPassword">
                  {{ attendeLabDetails.TempPassword }}
                </div>

              </div>
              <a role="button" ngxClipboard class="ml-2" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('PASSWORD_LABEL' | translate) + ' : ' + attendeLabDetails.TempPassword"
                [cbContent]="attendeLabDetails.TempPassword" href="javascript:void(0)"
                attr.aria-label="{{'COPY' | translate}} password">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

          </div>

          <!-- Extra Info -->
          <div class="pt-3 pl-2">

            <div *ngIf="attendeLabDetails.PreGuideUrl">
              {{ 'INSTRUCTION_PREREQUISITES_FOR_LAB' | translate }}
              <a href="{{attendeLabDetails.PreGuideUrl}}" target="_blank">
                {{ "CLICK_HERE" | translate }}
              </a>
            </div>

            <div class="pt-2">
              {{ 'INSTRUCTION_AZURE_PASS_LAUNCH_LAB' | translate }}
            </div>

          </div>

        </div>

      </div>

    </div>

    <!-- AWS Credentials -->
    <div class="guide-tabs mb-2" [class.showtab]="selectedTab === 'Aws'">

      <!-- 🔷 Instruction Box -->
      <div class="row" *ngIf="labDetail.DoNotSendCloudCredentials !== true">
        <!-- <div class="col-md-12 pt-2 pb-4">

          <div class="alert d-flex align-items-center info-box">
            <i class="fa-solid fa-info-circle mr-3"></i>

            <div *ngIf="!cloudprovider?.CustomInstruction" [innerHTML]="'INSTRUCTION_AWS_LOGIN_RDP' | translate"></div>

            <div *ngIf="cloudprovider?.CustomInstruction" [innerHTML]="cloudprovider.CustomInstruction"></div>
          </div>

        </div> -->

        <!-- 🔷 AWS Credentials Card -->
        <div class="col-md-12">

          <!-- Modern Card -->
          <div class="card border rounded-lg shadow-sm overflow-hidden">

            <!-- Header -->
            <div class="card-header bg-light-primary py-2 px-3 d-flex justify-content-between align-items-center">

              <div class="d-flex align-items-center">
                <img src="../../../../assets/images/aws.png" alt="AWS logo" width="26" class="icon-size mr-2">

                <strong class="font-14 mb-0">
                  {{ 'AMAZON_CREDENTIAL' | translate}}
                </strong>
              </div>

              <!-- Login Link -->
              <a href="https://aws.amazon.com/" target="_blank" class="text-primary font-weight-bold font-12"
              [attr.aria-label]="'CLICK_HERE_TO_LOGIN' | translate">
                {{ 'CLICK_HERE_TO_LOGIN' | translate }}
              </a>

            </div>

            <!-- Body -->
            <div class="card-body p-0">

              <!-- Sign-in Link -->
              <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                <div class="pr-3 flex-grow-1 overflow-hidden">

                  <div class="text-muted mb-1 font-12">
                    {{ 'SIGN-IN_LINK' | translate }}
                  </div>

                  <!-- Bootstrap only -->
                  <div class="font-14 mb-0 text-truncate w-100" [title]="awsLink">

                    {{ awsLink }}

                  </div>

                </div>

                <!-- Copy Icon -->
                <a role="button" ngxClipboard class="ml-2"
                  [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' sign-in link' + ' : ' + awsLink"
                  [cbContent]="awsLink" href="javascript:void(0)" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                  attr.aria-label="{{'COPY' | translate}} sign-in link">
                  <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                    [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                </a>

              </div>

              <!-- Username -->
              <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                <div class="pr-3 flex-grow-1 overflow-hidden">

                  <div class="text-muted mb-1 font-12">
                    {{ 'USERNAME' | translate }}
                  </div>

                  <div class="font-14 mb-0 text-break text-truncate w-100">
                    {{ cloudprovider.AADEmail }}
                  </div>

                </div>

                <a role="button" ngxClipboard class="ml-2"
                  [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('USERNAME' | translate) + ' : ' + cloudprovider.AADEmail"
                  [cbContent]="cloudprovider.AADEmail" href="javascript:void(0)" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                  attr.aria-label="{{'COPY' | translate}} username">
                  <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                    [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                </a>

              </div>

              <!-- Password -->
              <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                <div class="pr-3 flex-grow-1 overflow-hidden">

                  <div class="text-muted mb-1 font-12">
                    {{ 'PASSWORD' | translate }}
                  </div>

                  <div class="font-14 mb-0 text-break text-truncate w-100">
                    {{ cloudprovider.TempPassword }}
                  </div>

                </div>

                <a role="button" ngxClipboard class="ml-2"
                  [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('PASSWORD_LABEL' | translate) + ' : ' + cloudprovider.TempPassword"
                  [cbContent]="cloudprovider.TempPassword" href="javascript:void(0)"
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" attr.aria-label="{{'COPY' | translate}} password">
                  <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                    [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                </a>

              </div>

            </div>

          </div>

        </div>
      </div>

      <!-- 🔷 Resource Groups -->
      <div class="row mt-3" *ngFor="let rg of cloudprovider.DeploymentOutputValues">

        <div class="col-md-12">

          <!-- Modern Card -->
          <div class="card border rounded-lg shadow-sm overflow-hidden">

            <!-- Header -->
            <div class="card-header bg-light-primary py-2 px-3 d-flex align-items-center">

              <i class="fa-solid fa-flask text-primary mr-3"></i>

              <strong class="font-14 mb-0">
                {{ 'ENVIRONMENT_INFORMATION' | translate }}
              </strong>

            </div>

            <!-- Body -->
            <div class="card-body p-0">

              <ng-container *ngFor="let row of rg.OutputValues">

                <div *ngIf="!row.ExcludeOutputParameter"
                  class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                  <!-- Left -->
                  <div class="pr-3 flex-grow-1 overflow-hidden">

                    <div class="text-muted mb-1 font-12">
                      {{ row.Name | pascalCase }}
                    </div>

                    <div class="font-14 mb-0 text-truncate w-100" [title]="row.Value">

                      {{ row.Value }}

                    </div>

                  </div>

                  <!-- Copy -->
                  <a role="button" ngxClipboard class="ml-2"
                    [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + (row.Name | pascalCase) + ' : ' + row.Value"
                    [attr.aria-label]="'Click to copy value of ' + row.Name + ' : ' + row.Value" [cbContent]="row.Value"
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" href="javascript:void(0)">
                    <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                      [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                      [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                  </a>

                </div>

              </ng-container>

            </div>

          </div>

        </div>

      </div>

      <!-- 🔷 Launch Buttons (UNCHANGED teams-button ✅) -->
      <div *ngIf="labDetail.EnableAccessOverHttp && minGuide === false" class="row">
        <div class="col-md-12 text-center">

          <div *ngFor="let vm of cloudprovider.VMLaunchURL" style="padding:10px;display:inline-block;">
            <teams-button
              [classList]="'btn button-height-1 ts-btn ts-btn-fluent ts-btn-fluent-primary ts-btn-width-default btn-sm'"
              aria-label="Launch url" role="button" [titleText]="'LAUNCH_VM_IN_BROWSER' | translate" appDebounceClick
              (debounceClick)="onLaunchClick(vm)" *ngIf="vm.LaunchURL !== null" style="width:200px;"><i alt=""
                role="img" aria-label="img" aria-hidden="true" class="fa-solid fa-arrow-right"></i> {{ 'GO_TO' | translate}}
              {{vm.VMName}}
            </teams-button>

          </div>

        </div>
      </div>

      <!-- 🔷 URLs Section -->
      <div class="row pb-4 lab_Urls">
        <div class="col-md-12">
          <div *ngIf="attendeLabDetails.LabGuideUrl && type === null" style="padding:5px 0">
            <strong>{{ 'LAB_GUIDE' | translate }}</strong>
            <a href="{{attendeLabDetails.LabGuideUrl}}" target="_blank">
              {{ "CLICK_HERE" | translate }}
            </a>
          </div>

          <div *ngIf="attendeLabDetails.LabInformationURL" style="padding:5px 0">
            <strong>{{ 'HELP_DOCUMEN_URL' | translate }}</strong>
            <a href="{{attendeLabDetails.LabInformationURL}}" target="_blank">
              {{ "CLICK_HERE" | translate }}
            </a>
          </div>

          <div *ngIf="attendeLabDetails.PreGuideUrl" style="padding:5px 0">
            {{ 'INSTRUCTION_PREREQUISITES_FOR_LAB' | translate }}
            <a href="{{attendeLabDetails.PreGuideUrl}}" target="_blank">
              {{ "CLICK_HERE" | translate }}
            </a>
          </div>

        </div>
      </div>

    </div>

    <!--GCP Credentials -->
    <div class="guide-tabs mb-2" [class.showtab]="selectedTab === 'Gcp'">

      <!-- 🔷 Instruction Box -->
      <div class="row" *ngIf="labDetail.DoNotSendCloudCredentials !== true">
        <!-- <div class="col-md-12 pt-2 pb-4">

          <div class="alert d-flex align-items-center info-box">
            <i class="fa-solid fa-info-circle mr-3"></i>

            <div *ngIf="!cloudprovider?.CustomInstruction"
              [innerHTML]="'INSTRUCTION_GCP_LOGIN_RDP' | translate:{gcpLink: gcpLink}">
            </div>

            <div *ngIf="cloudprovider?.CustomInstruction" [innerHTML]="cloudprovider.CustomInstruction">
            </div>
          </div>

        </div> -->

        <!-- 🔷 GCP Credentials Card -->
        <div class="col-md-12">

          <div class="card border rounded-lg shadow-sm overflow-hidden">

            <!-- Header -->
            <div class="card-header  bg-light-primary py-2 px-3 d-flex justify-content-between align-items-center">

              <div class="d-flex align-items-center">
                <img src="../../../../assets/images/gcp.png" alt="GCP logo" width="26" class="icon-size mr-2">
                <strong class="font-14 mb-0">
                  {{'GOOGLE_CREDENTIAL' | translate}}
                </strong>
              </div>

              <!-- Login -->
              <a [href]="gcpLink" target="_blank" class="text-primary font-weight-medium font-12"
              [attr.aria-label]="'CLICK_HERE_TO_LOGIN' | translate">
                {{ 'CLICK_HERE_TO_LOGIN' | translate }}
              </a>

            </div>

            <!-- Sign In Link -->
            <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

              <div class="pr-3 flex-grow-1 overflow-hidden">

                <div class="text-muted mb-1 font-12">
                  {{ 'SIGN-IN_LINK' | translate }}
                </div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="gcpLink">
                  {{ gcpLink }}
                </div>

              </div>
              <a role="button" ngxClipboard class="ml-2" [cbContent]="gcpLink" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' Sign-in link' + ' : ' + gcpLink"
                attr.aria-label="Click to copy Sign-in link" href="javascript:void(0)" title="{{'COPY' | translate}}">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

            <!-- Username -->
            <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

              <div class="pr-3 flex-grow-1 overflow-hidden">
                <div class="text-muted mb-1 font-12">{{ 'USERNAME' | translate }}</div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="cloudprovider.AADEmail">
                  {{ cloudprovider.AADEmail }}
                </div>
              </div>
              <a role="button" ngxClipboard class="ml-2"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('USERNAME' | translate) + ' : ' + cloudprovider.AADEmail"
                [cbContent]="cloudprovider.AADEmail" href="javascript:void(0)" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                attr.aria-label="{{'COPY' | translate}} username">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

            <!-- Password -->
            <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

              <div class="pr-3 flex-grow-1 overflow-hidden">
                <div class="text-muted mb-1 font-12">{{ 'PASSWORD' | translate }}</div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="cloudprovider.TempPassword">
                  {{ cloudprovider.TempPassword }}
                </div>
              </div>
              <a role="button" ngxClipboard class="ml-2"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('PASSWORD_LABEL' | translate)  + ' : ' + cloudprovider.TempPassword"
                [cbContent]="cloudprovider.TempPassword" href="javascript:void(0)"
                [id]="pasteInVM ? 'pasteInsideVM' : ''" attr.aria-label="{{'COPY' | translate}}">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

            <!-- Organization -->
            <div *ngIf="cloudprovider.TenantDomainName"
              class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

              <div class="pr-3 flex-grow-1 overflow-hidden font-12">
                <div class="text-muted mb-1">{{ 'ORGANIZATION' | translate }}</div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="cloudprovider.TenantDomainName">
                  {{ cloudprovider.TenantDomainName }}
                </div>
              </div>
              <a role="button" ngxClipboard class="ml-2" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('ORGANIZATION' | translate) + ' : ' + cloudprovider.TenantDomainName"
                [cbContent]="cloudprovider.TenantDomainName" href="javascript:void(0)"
                attr.aria-label="{{'COPY' | translate}}">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

            <!-- Project -->
            <div *ngIf="cloudprovider.ResourceGroupName"
              class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

              <div class="pr-3 flex-grow-1 overflow-hidden">
                <div class="text-muted mb-1 font-12">{{ 'PROJECT' | translate }}</div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="cloudprovider.ResourceGroupName">
                  {{ cloudprovider.ResourceGroupName }}
                </div>
              </div>
              <a role="button" ngxClipboard class="ml-2" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('PROJECT_NAME' | translate) + ' : ' + cloudprovider.ResourceGroupName"
                [cbContent]="cloudprovider.ResourceGroupName" href="javascript:void(0)"
                attr.aria-label="{{'COPY' | translate}}">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

          </div>

        </div>
      </div>

      <!-- 🔷 Resource Groups -->
      <div class="row mt-3" *ngFor="let rg of cloudprovider.DeploymentOutputValues">

        <div class="col-md-12">

          <div class="card border rounded-lg shadow-sm overflow-hidden">

            <!-- Header -->
            <div class="card-header bg-light-primary py-2 px-3 d-flex align-items-center">

              <i class="fa-solid fa-flask text-primary mr-3"></i>

              <strong class="font-14 mb-0">
                {{ 'ENVIRONMENT_INFORMATION' | translate }}
              </strong>

            </div>

            <!-- Dynamic Rows -->
            <ng-container *ngFor="let row of rg.OutputValues">

              <div *ngIf="!row.ExcludeOutputParameter"
                class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                <!-- Left -->
                <div class="pr-3 flex-grow-1 overflow-hidden">

                  <!-- Label -->
                  <div class="text-muted mb-1 font-12">
                    {{ row.Name | pascalCase }}
                  </div>

                  <!-- Value -->
                  <div class="font-14 mb-0 text-truncate w-100" [title]="row.Value">

                    {{ row.Value }}

                  </div>

                </div>

                <!-- Copy -->
                <a role="button" ngxClipboard class="ml-2"
                  [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + (row.Name | pascalCase) + ' : ' + row.Value"
                  [attr.aria-label]="'Click to copy value of ' + row.Name + ' : ' + row.Value" [cbContent]="row.Value"
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" href="javascript:void(0)">
                  <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                    [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                </a>

              </div>

            </ng-container>

          </div>

        </div>

      </div>
      <!-- 🔷 Launch Buttons (UNCHANGED ✅) -->
      <div *ngIf="labDetail.EnableAccessOverHttp && minGuide === false" class="row">
        <div class="col-md-12 text-center">

          <div *ngFor="let vm of cloudprovider.VMLaunchURL" style="padding:10px;display:inline-block;">
            <teams-button aria-label="Launch url" role="button" [titleText]="'LAUNCH_VM_IN_BROWSER' | translate"
              (debounceClick)="onLaunchClick(vm)" appDebounceClick *ngIf="vm.LaunchURL !== null">
              <i alt="" role="img" aria-label="img" aria-hidden="true" class="fa-solid fa-arrow-right"></i>
              {{ 'GO_TO' | translate}} {{vm.VMName}}
            </teams-button>

          </div>

        </div>
      </div>

      <!-- 🔷 URLs Section -->
      <div class="row pb-4 lab_Urls">
        <div class="col-md-12">
          <div *ngIf="attendeLabDetails.LabGuideUrl && type === null" style="padding:5px 0">
            <strong>{{ 'LAB_GUIDE' | translate }}</strong>
            <a href="{{attendeLabDetails.LabGuideUrl}}" target="_blank">
              {{ "CLICK_HERE" | translate }}
            </a>
          </div>

          <div *ngIf="attendeLabDetails.LabInformationURL" style="padding:5px 0">
            <strong>{{ 'HELP_DOCUMEN_URL' | translate }}</strong>
            <a href="{{attendeLabDetails.LabInformationURL}}" target="_blank">
              {{ "CLICK_HERE" | translate }}
            </a>
          </div>

          <div *ngIf="attendeLabDetails.PreGuideUrl" style="padding:5px 0">
            {{ 'INSTRUCTION_PREREQUISITES_FOR_LAB' | translate }}
            <a href="{{attendeLabDetails.PreGuideUrl}}" target="_blank">
              {{ "CLICK_HERE" | translate }}
            </a>
          </div>

        </div>
      </div>

    </div>

    <!-- OCI Credentials -->
    <div class="guide-tabs mb-2" [class.showtab]="selectedTab === 'Oci'">

      <!-- 🔷 Instruction -->
      <div class="row" *ngIf="labDetail.DoNotSendCloudCredentials !== true">
        <!-- <div class="col-md-12 pt-2 pb-4">

          <div class="alert info-box">
            <i class="fa-solid fa-info-circle mr-2"></i>

            <div *ngIf="!cloudprovider?.CustomInstruction"
              [innerHTML]="'INSTRUCTION_OCI_LOGIN_RDP' | translate:{ociLink: ociLink}">
            </div>

            <div *ngIf="cloudprovider?.CustomInstruction" [innerHTML]="cloudprovider.CustomInstruction">
            </div>

          </div>

        </div> -->

        <!-- 🔷 Credentials Card -->
        <div class="col-md-12">

          <div class="card border rounded-lg shadow-sm overflow-hidden">

            <!-- Header -->
            <div class="card-header bg-light-primary py-2 px-3 d-flex justify-content-between align-items-center">

              <div class="d-flex align-items-center">
                <img src="../../../../assets/images/oracle.png" alt="oracle logo" width="26" class="icon-size mr-2">
                <strong class="font-14 mb-0">
                  {{'ORACLE_CREDENTIAL' | translate}}
                </strong>
              </div>

              <!-- Login -->
              <a [href]="ociLink" target="_blank" [attr.aria-label]="'CLICK_HERE_TO_LOGIN' | translate" class="text-primary font-weight-medium font-12">
                {{ 'CLICK_HERE_TO_LOGIN' | translate }}
              </a>

            </div>

            <!-- Sign In Link -->
            <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

              <div class="pr-3 flex-grow-1 overflow-hidden">

                <div class="text-muted mb-1 font-14">
                  {{ 'SIGN-IN_LINK' | translate }}
                </div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="ociLink">
                  {{ ociLink }}
                </div>

              </div>
              <a role="button" ngxClipboard class="ml-2"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + 'sign-in link' + ' : ' + ociLink"
                [cbContent]="ociLink" href="javascript:void(0)" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                attr.aria-label="{{'COPY' | translate}} sign-in link">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

            <!-- Tenant -->
            <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

              <div class="pr-3 flex-grow-1 overflow-hidden">

                <div class="text-muted mb-1 font-12">
                  {{ 'OCI_TENANT_NAME' | translate }}
                </div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="cloudprovider.TenantDomainName">
                  {{ cloudprovider.TenantDomainName }}
                </div>

              </div>
              <a role="button" ngxClipboard class="ml-2"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('OCI_TENANT_NAME' | translate) + ' : ' + cloudprovider.TenantDomainName"
                [cbContent]="cloudprovider.TenantDomainName" href="javascript:void(0)"
                [id]="pasteInVM ? 'pasteInsideVM' : ''" attr.aria-label="{{'COPY' | translate}} tenantdomainname">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

            <!-- Domain -->
            <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

              <div class="pr-3 flex-grow-1 overflow-hidden">

                <div class="text-muted mb-1 font-12">
                  {{ 'OCI_DOMAIN_NAME' | translate }}
                </div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="cloudprovider.AADDomain">
                  {{ cloudprovider.AADDomain }}
                </div>

              </div>
              <a role="button" ngxClipboard class="ml-2"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('OCI_DOMAIN_NAME' | translate) + ' : ' + cloudprovider.AADDomain"
                [cbContent]="cloudprovider.AADDomain" href="javascript:void(0)" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                attr.aria-label="{{'COPY' | translate}} aaddomain">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

            <!-- Username -->
            <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

              <div class="pr-3 flex-grow-1 overflow-hidden">

                <div class="text-muted mb-1 font-12">
                  {{ 'USERNAME' | translate }}
                </div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="cloudprovider.AADEmail">
                  {{ cloudprovider.AADEmail }}
                </div>

              </div>
              <a role="button" ngxClipboard class="ml-2"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('USERNAME' | translate) + ' : ' + cloudprovider.AADEmail"
                [cbContent]="cloudprovider.AADEmail" href="javascript:void(0)" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                attr.aria-label="{{'COPY' | translate}} username">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

            <!-- Password -->
            <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

              <div class="pr-3 flex-grow-1 overflow-hidden">

                <div class="text-muted mb-1 font-12">
                  {{ 'PASSWORD' | translate }}
                </div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="cloudprovider.TempPassword">
                  {{ cloudprovider.TempPassword }}
                </div>

              </div>
              <a role="button" ngxClipboard class="ml-2" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('PASSWORD_LABEL' | translate) + ' : ' + cloudprovider.TempPassword"
                [cbContent]="cloudprovider.TempPassword" href="javascript:void(0)"
                attr.aria-label="{{'COPY' | translate}} password">
                <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                  [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
              </a>

            </div>

          </div>

        </div>
      </div>

      <!-- 🔷 Compartments -->

      <div class="row mt-3" *ngFor="let rg of cloudprovider.DeploymentOutputValues">

        <div class="col-md-12">

          <div class="card border rounded-lg shadow-sm overflow-hidden">

            <!-- Header -->
            <div class="card-header bg-light-primary py-2 px-3  d-flex align-items-center">

              <i class="fa-solid fa-flask text-primary mr-3"></i>

              <div>
                <strong class="font-14 mb-0 d-block">
                  {{ 'ENVIRONMENT_INFORMATION' | translate }}: {{ rg.ResourceGroupName }}
                </strong>

                <!-- <small class="text-muted font-14">
                  {{ 'OCI-COMPARTMENT' | translate }} : {{ rg.ResourceGroupName }}
                </small> -->
              </div>

            </div>

            <!-- Rows -->
            <ng-container *ngFor="let row of rg.OutputValues">

              <div *ngIf="!row.ExcludeOutputParameter"
                class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                <!-- Left -->
                <div class="pr-3 flex-grow-1 overflow-hidden">

                  <!-- Label -->
                  <div class="text-muted mb-1 font-12">
                    {{ row.Name | pascalCase }}
                  </div>

                  <!-- Value -->
                  <div class="font-14 mb-0 text-truncate w-100" [title]="row.Value">

                    {{ row.Value }}

                  </div>

                </div>

                <!-- Copy -->
                <a role="button" ngxClipboard class="ml-2"
                  [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + (row.Name | pascalCase) + ' : ' + row.Value"
                  [attr.aria-label]="'Click to copy value of ' + row.Name + ' : ' + row.Value" [cbContent]="row.Value"
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" href="javascript:void(0)">
                  <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                    [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                </a>

              </div>

            </ng-container>

          </div>

        </div>

      </div>

      <!-- 🔷 Launch Buttons (UNCHANGED) -->
      <div *ngIf="labDetail.EnableAccessOverHttp && minGuide === false" class="row">
        <div class="col-md-12 text-center">

          <div *ngFor="let vm of cloudprovider.VMLaunchURL" style="padding:10px;display:inline-block;">

            <teams-button [classList]="'btn button-height-1 ts-btn ts-btn-fluent ts-btn-fluent-primary btn-sm'"
              aria-label="Launch url" role="button" [titleText]="'LAUNCH_VM_IN_BROWSER' | translate" appDebounceClick
              (debounceClick)="onOpenVm(vm)" *ngIf="vm.LaunchURL !== null">

              <i class="fa-solid fa-arrow-right"></i>
              {{ 'GO_TO' | translate }} {{ vm.VMName }}

            </teams-button>

          </div>

        </div>
      </div>

      <!-- 🔷 Links -->
      <div class="row pb-4 lab_Urls">
        <div class="col-md-12">
          <div *ngIf="attendeLabDetails.LabGuideUrl && type === null">
            <strong>{{ 'LAB_GUIDE' | translate }}</strong>
            <a href="{{attendeLabDetails.LabGuideUrl}}" target="_blank">
              {{ "CLICK_HERE" | translate }}
            </a>
          </div>

          <div *ngIf="attendeLabDetails.LabInformationURL">
            <strong>{{ 'HELP_DOCUMEN_URL' | translate }}</strong>
            <a href="{{attendeLabDetails.LabInformationURL}}" target="_blank">
              {{ "CLICK_HERE" | translate }}
            </a>
          </div>

          <div *ngIf="attendeLabDetails.PreGuideUrl">
            {{ 'INSTRUCTION_PREREQUISITES_FOR_LAB' | translate }}
            <a href="{{attendeLabDetails.PreGuideUrl}}" target="_blank">
              {{ "CLICK_HERE" | translate }}
            </a>
          </div>

        </div>
      </div>

    </div>

    <!--Licenses-->
    <div class="guide-tabs mb-2" [class.showtab]="selectedTab === 'Licenses' && cloudprovider.Licenses.length > 0">

      <div class="row">

        <div class="col-md-12">

          <!-- Modern Card -->
          <div class="card border rounded-lg shadow-sm overflow-hidden">

            <!-- Header -->
            <div class="card-header bg-light-primary py-2 px-3 d-flex align-items-center">

              <i class="fa-solid fa-certificate text-primary mr-3"></i>

              <strong class="font-14 mb-0">
                {{ labDetail.LicenseLabel ? labDetail.LicenseLabel : ('LICENSES' | translate) }}
              </strong>

            </div>

            <!-- Dynamic Rows -->
            <ng-container *ngFor="let row of cloudprovider.Licenses">

              <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                <!-- Left -->
                <div class="pr-3 flex-grow-1 overflow-hidden">

                  <!-- Label -->
                  <div class="text-muted mb-1 font-12">
                    {{ row.LicenseTypeName }}
                  </div>

                  <!-- Value -->
                  <div class="font-14 mb-0 text-truncate w-100" [title]="row.AzurePasses">

                    {{ row.AzurePasses }}

                  </div>

                </div>

                <!-- Copy -->
                <a role="button" ngxClipboard class="ml-2"
                  [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + (row.LicenseTypeName | pascalCase) + ' : ' + row.AzurePasses"
                  [attr.aria-label]="'Click to copy value of ' + row.LicenseTypeName + ' : ' + row.AzurePasses"
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" [cbContent]="row.AzurePasses" href="javascript:void(0)">
                  <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                    [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                </a>

              </div>

            </ng-container>

          </div>

        </div>

      </div>

    </div>

    <!-- Resource -->
    <div class="guide-tabs mb-2"
      [class.showtab]="selectedTab === 'Resource' && cloudprovider.DeploymentOutputValues?.length > 0">

      <!-- Resource Groups -->
      <div class="row" *ngFor="let rg of cloudprovider.DeploymentOutputValues">

        <ng-container *ngIf="rg?.OutputValues?.length > 0">

          <div class="col-md-12 mb-3">

            <!-- Modern Card -->
            <div class="card border rounded-lg shadow-sm overflow-hidden">

              <!-- Header -->
              <div class="card-header bg-light-primary py-2 px-3 d-flex align-items-center">

                <i class="fa-solid fa-folder-open text-primary mr-3"></i>

                <div>
                  <strong class="font-14 mb-0 d-block">
                    {{ 'ENVIRONMENT_INFORMATION' | translate }}: {{ rg.ResourceGroupName }}
                  </strong>

                  <!-- <small class="text-muted">
                    {{ 'RESOURCE_GROUP' | translate }} : {{ rg.ResourceGroupName }}
                  </small> -->
                </div>

              </div>

              <!-- Dynamic Rows -->
              <ng-container *ngFor="let row of rg.OutputValues">

                <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                  <!-- Left -->
                  <div class="pr-3 flex-grow-1 overflow-hidden">

                    <!-- Label -->
                    <div class="text-muted mb-1 font">
                      {{ row.Name | pascalCase }}
                    </div>

                    <!-- Value -->
                    <div class="font-14 mb-0 text-truncate w-100" [title]="row.Value">

                      {{ row.Value }}

                    </div>

                  </div>

                  <!-- Copy -->
                  <a role="button" ngxClipboard class="ml-2" [attr.aria-label]="'Click to copy value of ' + row.Name"
                    [cbContent]="row.Value" href="javascript:void(0)" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                    title="{{'COPY' | translate}}">
                    <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                      [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                      [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                  </a>

                </div>

              </ng-container>

            </div>

          </div>

        </ng-container>

      </div>

      <!-- Launch Buttons (UNCHANGED) -->
      <div *ngIf="labDetail.EnableAccessOverHttp && minGuide === false" class="row">

        <div class="col-md-12 text-center">

          <div *ngFor="let vm of cloudprovider.VMLaunchURL" style="padding:10px;display:inline-block;">

            <teams-button aria-label="Launch url" role="button" [titleText]="'LAUNCH_VM_IN_BROWSER' | translate"
              appDebounceClick (debounceClick)="onOpenVm(vm)" *ngIf="vm.LaunchURL !== null">

              <i alt="" role="img" aria-label="img" aria-hidden="true" class="fa-solid fa-arrow-right">
              </i>

              {{ 'GO_TO' | translate }} {{ vm.VMName }}

            </teams-button>

          </div>

        </div>

      </div>

    </div>

    <!-- Service Tab -->
    <div class="guide-tabs mb-2" [class.showtab]="selectedTab === 'Service'" id="service" aria-labelledby="service">

      <div class="row">
        <div class="col-md-12">

          <!-- Modern Card -->
          <div class="card border rounded-lg shadow-sm mb-4 overflow-hidden">

            <!-- Header -->
            <div class="card-header bg-light-primary bg-light px-3 py-2 d-flex align-items-center">

              <i class="fa-solid fa-key text-primary mr-3"></i>

              <strong class="font-14 mb-0">
                {{ 'SERVICE_PRINCIPAL_DETAILS' | translate }}
              </strong>

            </div>

            <!-- Rows -->
            <div class="card-body p-0">

              <!-- Subscription ID -->
              <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                <div class="pr-3 font-12 flex-grow-1">
                  <div class="text-muted mb-1">
                    {{ 'SUBSCRIPTION_ID' | translate }}
                  </div>

                  <div class="font-14 mb-0 text-break">
                    {{ cloudprovider.SubscriptionGuid }}
                  </div>
                </div>
                <a role="button" class="ml-2"
                  [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('SUBSCRIPTION_ID' | translate) + ' : ' + cloudprovider.SubscriptionGuid"
                  ngxClipboard aria-label="Click to copy Subscription Id" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                  [cbContent]="cloudprovider.SubscriptionGuid" href="javascript:void(0)"
                  attr.aria-label="{{'COPY' | translate}}">
                  <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                    [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                </a>

              </div>

              <!-- Tenant ID -->
              <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                <div class="pr-3 font-12 flex-grow-1">
                  <div class="text-muted mb-1">
                    {{ 'TENANT_ID' | translate }}
                  </div>

                  <div class="font-14 mb-0 text-break">
                    {{ cloudprovider.TenantId }}
                  </div>
                </div>
                <a role="button" ngxClipboard class="ml-2" aria-label="Click to copy Tenant Id"
                  [cbContent]="cloudprovider.TenantId" href="javascript:void(0)" [id]="pasteInVM ? 'pasteInsideVM' : ''"
                  [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('TENANT_ID' | translate) + ' : ' + cloudprovider.TenantId"
                  attr.aria-label="{{'COPY' | translate}}">
                  <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                    [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                </a>

              </div>

              <!-- Application ID -->
              <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                <div class="pr-3 flex-grow-1 overflow-hidden">
                  <div class="text-muted mb-1 font-12">
                    {{ 'APPLICATION_ID' | translate }}
                  </div>

                  <div class="font-14 mb-0 text-break">
                    {{ cloudprovider.AADSPAppId }}
                  </div>
                </div>
                <a role="button" ngxClipboard class="ml-2" aria-label="Click to copy Application Id"
                  [cbContent]="cloudprovider.AADSPAppId" href="javascript:void(0)"
                  [id]="pasteInVM ? 'pasteInsideVM' : ''"
                  [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('APPLICATION_ID' | translate) + ' : ' + cloudprovider.AADSPAppId"
                  attr.aria-label="{{'COPY' | translate}}">
                  <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                    [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                </a>

              </div>

              <!-- Secret Key -->
              <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                <div class="pr-3 flex-grow-1 overflow-hidden">
                  <div class="text-muted mb-1 font-12">
                    {{ 'SECRET_KEY' | translate }}
                  </div>

                  <div class="font-14 mb-0 text-break">
                    {{ cloudprovider.AADSPAppKey }}
                  </div>
                </div>
                <a role="button" ngxClipboard class="ml-2" aria-label="Click to copy Secret Key"
                  [cbContent]="cloudprovider.AADSPAppKey" href="javascript:void(0)"
                  [id]="pasteInVM ? 'pasteInsideVM' : ''"
                  [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('SECRET_KEY' | translate) + ' : ' + cloudprovider.AADSPAppKey"
                  attr.aria-label="{{'COPY' | translate}}">
                  <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                    [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                </a>

              </div>

              <!-- Display Name -->
              <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                <div class="pr-3 flex-grow-1 overflow-hidden">
                  <div class="text-muted mb-1 font-12">
                    {{ 'DISPLAY_NAME' | translate }}
                  </div>

                  <div class="font-14 mb-0 text-break">
                    {{ cloudprovider.AADSPDisplayName }}
                  </div>
                </div>
                <a role="button" ngxClipboard class="ml-2" aria-label="Click to copy Display Name"
                  [id]="pasteInVM ? 'pasteInsideVM' : ''" [cbContent]="cloudprovider.AADSPDisplayName"
                  href="javascript:void(0)"
                  [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('DISPLAY_NAME' | translate) + ' : ' + cloudprovider.AADSPDisplayName"
                  attr.aria-label="{{'COPY' | translate}}">
                  <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                    [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                </a>

              </div>

              <!-- Application ID URI -->
              <div *ngIf="cloudprovider?.AADSPNAppIdURI"
                class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                <div class="pr-3 flex-grow-1 overflow-hidden">
                  <div class="text-muted mb-1 font-12">
                    {{ 'APPLICATION_ID_URI' | translate }}
                  </div>

                  <div class="font-14 mb-0 text-break">
                    {{ cloudprovider.AADSPNAppIdURI }}
                  </div>
                </div>
                <a role="button" ngxClipboard class="ml-2" aria-label="Click to copy Application ID URI"
                  [cbContent]="cloudprovider.AADSPNAppIdURI" href="javascript:void(0)"
                  [id]="pasteInVM ? 'pasteInsideVM' : ''"
                  [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('APPLICATION_ID_URI' | translate) + ' : ' + cloudprovider.AADSPNAppIdURI"
                  attr.aria-label="{{'COPY' | translate}}">
                  <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                    [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                </a>

              </div>

              <!-- Tenant Domain -->
              <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

                <div class="pr-3 flex-grow-1 overflow-hidden">
                  <div class="text-muted mb-1 font-12">
                    {{ 'TENANT_DOMAIN_NAME' | translate }}
                  </div>

                  <div class="font-14 mb-0 text-break">
                    {{ cloudprovider.TenantDomainName }}
                  </div>
                </div>
                <a role="button" ngxClipboard class="ml-1" aria-label="Click to Copy Tenant Domain Name"
                  [cbContent]="cloudprovider.TenantDomainName" href="javascript:void(0)"
                  [id]="pasteInVM ? 'pasteInsideVM' : ''"
                  [tooltip]="(pasteInVM ? ('CLICK_TO_PASTE' | translate) : ('COPY' | translate)) + ' ' + ('TENANT_DOMAIN_NAME' | translate) + ' : ' + cloudprovider.TenantDomainName"
                  attr.aria-label="{{'COPY' | translate}}">
                  <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                    [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                    [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                </a>

              </div>

            </div>

          </div>

        </div>
      </div>

    </div>

    <!-- Access key details -->

    <div class="guide-tabs mb-2" [class.showtab]="selectedTab === 'Access key details'" id="Access-key-details"
      role="tabpanel" aria-labelledby="resource-tab">

      <div class="row">

        <div class="col-md-12">

          <!-- Modern Card -->
          <div class="card border rounded-lg shadow-sm overflow-hidden">

            <!-- Header -->
            <div class="card-header bg-light-primary py-2 px-3 px-4 py-3 d-flex align-items-center">

              <i class="fa-solid fa-key text-primary mr-3"></i>

              <strong class="font-14 mb-0">
                {{ 'ACCESS_KEY_DETAILS' | translate }}
              </strong>

            </div>

            <!-- Access Key -->
            <div class="border-top  px-3 py-2 d-flex justify-content-between align-items-center">

              <!-- Left -->
              <div class="pr-3 flex-grow-1 overflow-hidden">

                <div class="text-muted mb-1 font-12">
                  {{ 'ACCESS_KEY' | translate }}
                </div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="cloudprovider.AADSPAppId">

                  {{ cloudprovider.AADSPAppId }}

                </div>

              </div>

              <!-- Copy -->
              <a role="button" ngxClipboard class="ml-2" aria-label="Click to copy access key"
                      [id]="pasteInVM ? 'pasteInsideVM' : ''" [cbContent]="cloudprovider.AADSPAppId"
                      href="javascript:void(0)" title="{{'COPY' | translate}}">
                      <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                        [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                        [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                    </a>

            </div>

            <!-- Secret Key -->
            <div class="border-top px-3 py-2 d-flex justify-content-between align-items-center">

              <!-- Left -->
              <div class="pr-3 flex-grow-1 overflow-hidden">

                <div class="text-muted mb-1 font-12">
                  {{ 'SECRET_KEY' | translate }}
                </div>

                <div class="font-14 mb-0 text-truncate w-100" [title]="cloudprovider.AADSPAppKey">

                  {{ cloudprovider.AADSPAppKey }}

                </div>

              </div>

              <!-- Copy -->
              <a role="button" ngxClipboard class="ml-2" aria-label="Click to Copy Secret Key"
                      [id]="pasteInVM ? 'pasteInsideVM' : ''" [cbContent]="cloudprovider.AADSPAppKey"
                      href="javascript:void(0)" title="{{'COPY' | translate}}">
                      <i role="img" id="elementEnv" aria-hidden="true" aria-label="img" alt=""
                        [id]="pasteInVM ? 'pasteInsideVM' : ''" class="copyelmnt primary-color"
                        [ngClass]="pasteInVM ? 'fa-regular fa-paste' : 'fa-regular fa-clone'"></i>
                    </a>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>
</div>